import React from "react";
import { connect } from "react-redux";
import { getters } from "../model";
import EditContact from "./EditContact";
import Loading from "ui-kit/Loading";
import * as FIELD_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids";
import detailStyles from "Portal/NewPortal/Sections/Sessions/FlyOver/View/Details/styles.scss";
import * as R from "ramda";
import classNames from "classnames";
import { getFields } from "../selectors";
import InfoPanel from "./InfoPanel";

const decorate = connect(state => ({
  loadingParticipant: getters.loadingParticipant(state),
  isEditingDetails: getters.isEditingDetails(state),
  contactData: getters.contactData(state),
  fields: getFields(state)
}));

const Details = ({ loadingParticipant, isEditingDetails = false, fields }) => {
  if (loadingParticipant) {
    return <Loading />;
  }

  if (isEditingDetails) {
    return <EditContact />;
  }

  return (
    <div className={detailStyles.participantContainer}>
      <div className={detailStyles.innerContainer}>
        <InfoPanel />

        {fields.map(field => {
          if (
            [FIELD_IDS.CONTACTS.ABOUT, FIELD_IDS.ACCOUNTS.DESCRIPTION].includes(
              field.id
            ) ||
            field.type === "wysiwyg"
          ) {
            const value = field.editable_value;
            return (
              <div className={detailStyles.description}>
                <div className={detailStyles.textBold}>{field.name}:</div>
                <div
                  className={classNames(
                    detailStyles.textRegular,
                    detailStyles.descriptionText
                  )}
                  dangerouslySetInnerHTML={{
                    __html: R.isEmpty(value) || R.isNil(value) ? "-" : value
                  }}
                />
              </div>
            );
          }

          return (
            <div key={field.id} className={detailStyles.row}>
              <div className={detailStyles.textBold}>{field.name}:</div>
              <div className={detailStyles.textRegular}>
                {field.plain_value && field.plain_value.length
                  ? field.plain_value
                  : "-"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default decorate(Details);
